import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b69da9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Escaneja el codi de la taula per administrar-la", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "video-container" }, [
  /*#__PURE__*/_createElementVNode("video", { id: "video" })
], -1))
const _hoisted_3 = { class: "close-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ng_template = _resolveComponent("ng-template")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.manualTableCode && _ctx.manualTableCode(...args)))
          }, "Introducir código"),
          _hoisted_2,
          _createVNode(_component_ion_modal, {
            ref: "modalIframe",
            "is-open": _ctx.tableSessionsOpen,
            "presenting-element": _ctx.$parent.$refs.ionRouterOutlet,
            onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => {_ctx.tableSessionsOpen = false; _ctx.openQrScanner();})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ng_template, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tableSessionsOpen = false))
                    }, [
                      _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                    ])
                  ]),
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      (_ctx.sessions.length === 0)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_4, "No hi ha sessions recents a aquesta taula"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (session) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: session.id,
                          onClick: ($event: any) => (_ctx.openTableSession(session))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["status-label", { 'active': session.active }])
                                }, null, 2),
                                _createTextVNode(_toDisplayString(new
                  Date(session.created_at).toLocaleDateString('es-es', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                  })), 1),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.currency(session.total)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "presenting-element"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}